import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_CONTACT](state, payload) {
    state.contact = payload;
  },
  [MutationsType.SET_CONTACTS](state, payload) {
    state.contacts = payload;
  },
  [MutationsType.SET_NEW_CONTACTS](state, payload) {
    state.newContacts = payload;
  },
  [MutationsType.SET_UNSUBSCRIBE_GET_CONTACT](state, payload) {
    state.unsubscribeGetContact = payload;
  },
  [MutationsType.ADD_CONTACT](state, payload) {
    state.contacts.push(payload);
  },
  [MutationsType.UPDATE_CONTACT](state, payload) {
    let ind = (state.contacts || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.contacts, ind, payload.value);

    if (state.contact && state.contact.id === payload.id) state.contact = { ...state.contact, ...payload };
  },
};
